import { capitalizeString } from "../utils/stringModifications";

export enum HistoricNarIngestionState {
  TOUCHLESS = "touchless",
  INGESTED_MANUAL = "ingested_manual",
  AGENTIC = "agentic",
  WATCHING = "watching",
  NEEDS_REVIEW = "needs_review",
  OTHER = "other",
}

export const HistoricNarIngestionStateBadgesDetails = [
  {
    id: HistoricNarIngestionState.TOUCHLESS,
    label: "Touchless",
    bgColor: "#EAF2FF",
    textColor: "#0056D6",
  },
  {
    id: HistoricNarIngestionState.INGESTED_MANUAL,
    label: "Ingested Manual",
    bgColor: "#FFFCD6",
    textColor: "#665D00",
  },
  {
    id: HistoricNarIngestionState.AGENTIC,
    label: "Agentic",
    bgColor: "#FFF3E0",
    textColor: "#C24400",
  },
  {
    id: HistoricNarIngestionState.WATCHING,
    label: "Not Ingested",
    bgColor: "#F5F5F5",
    textColor: "#0F0F0F",
  },
  {
    id: HistoricNarIngestionState.NEEDS_REVIEW,
    label: "Needs Review",
    bgColor: "#FFE8E8",
    textColor: "#CC0300",
  },
  {
    id: HistoricNarIngestionState.OTHER,
    label: "Other",
    bgColor: "#F5F5F5",
    textColor: "#0F0F0F",
  },
];

/** Resolve a known state badge, or use the Other palette for an unknown state. */
export const getHistoricNarIngestionStateBadge = (
  id: string,
): (typeof HistoricNarIngestionStateBadgesDetails)[number] => {
  const badge = HistoricNarIngestionStateBadgesDetails.find(
    (item) => item.id === id,
  );
  if (badge) return badge;

  const otherBadge = HistoricNarIngestionStateBadgesDetails.find(
    (item) => item.id === HistoricNarIngestionState.OTHER,
  )!;
  return { ...otherBadge, label: capitalizeString(id.replace(/_/g, " ")) };
};
